<template>
  <modal transition="pop-out" name="update-attributes-group" :width="550" :height="300">
    <div class="h-10 w-full border-b border-gray-200">
      <p class="px-8 py-2 text-gray-700">Update Attribute Group</p>
    </div>
    <div class="w-full">
      <form class="rounded px-8 pt-6 pb-8 mb-4" @submit.prevent>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Name
          </label>
          <input v-model="form.name" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Category Name">
          <p v-if="errors.includes('name')" class="text-red-500 text-xs italic">Please provide a name.</p>
        </div>
        <div class="mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Status
          </label>
          <el-switch v-model="form.status"></el-switch>
        </div>
        <div class="flex items-center justify-between">
          <el-button @click="submit" type="primary" :loading="updating">Update</el-button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'UpdateForm',
  data() {
    return {
      updating: false,
      errors: [],
    };
  },
  computed: {
    form() {
      return cloneDeep(this.$store.state.InventoryModule.Attributes.currentSelected.group);
    },
  },
  methods: {
    async submit() {
      this.errors = [];
      // formValidation is a mixin in
      // src/Common/mixins/index.js
      this.errors = this.formValidation(this.form);

      // check for error length
      if (this.errors.length === 0) {
        try {
          this.updating = true;

          const groupId = this.form.id;
          this.form = {
            name: this.form.name,
          };
          await this.$store.dispatch('InventoryModule/Attributes/updateAttributeGroup', {
            groupId,
            payload: this.form,
          });

          this.$modal.hide('update-attributes-group');
          this.$notify.success({
            title: 'Success',
            message: 'Group successfully updated',
          });
        } catch (e) {
          this.updating = false;
          if (e.message) {
            this.$notify.error({
              title: 'Error',
              message: e.message,
            });
          } else {
            this.$notify.error({
              title: 'Error',
              message: 'Something went wrong',
            });
          }
        }

        this.updating = false;
      }
    },
  },
};
</script>

<style scoped>

</style>
